@if (dockGroupsData$ | async; as dockGroups) {
  <app-filter-dropdown
    aria-label="Dock groups filter dropdown"
    [formControl]="formControl"
    [label]="'global.filter.dockGroups'"
    [multiple]="true"
    [options]="dockGroups"></app-filter-dropdown>
}
